import { createFileRoute } from '@tanstack/react-router';

import { PayrollStructureDetailLayoutContent } from './-components/PayrollStructureDetailLayoutContent';

export const Route = createFileRoute(
  '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout',
)({
  component: PayrollStructureDetailLayoutContent,
});
